// components/Apps/Quiz/QuizQuestion.js
import React from 'react';
import PropTypes from 'prop-types';

const QuizQuestion = ({ questionText, questionImage, children }) => {
  return (
    <div className="quiz__question">
      {questionText && (
        <div className="quiz__question-text">{questionText}</div>
      )}
      {questionImage && (
        <div className="quiz__question-image">
          <img src={questionImage} alt="Question" className="image image-img image-fit-cover" />
        </div>
      )}
      {children && (
        <div className="quiz__answers">{children}</div>
      )}
    </div>
  );
};

QuizQuestion.propTypes = {
  questionText:  PropTypes.string.isRequired,
  questionImage: PropTypes.string,
  children:      PropTypes.node,
};

export default QuizQuestion;